import jwt from 'jsonwebtoken';

const encrypt = (text, key, expiresInString = '30s') => {
  return jwt.sign({ data: text }, key, {
    expiresIn: expiresInString, // 30s 2h 1y 100y
  });
};

export { encrypt };
